<div class="flex-loading">
  <ion-label translate>common.updateApplication</ion-label>
  <ion-spinner name="crescent"></ion-spinner>
</div>
